import gql from 'graphql-tag'

export const poolsQuery = gql`
  query poolsQuery(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
    $block: Block_height # $where: Pool_filter! = { allocPoint_gt: 0, accNvlsPerShare_gt: 0 }
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, block: $block) {
      id
      pair
      allocPoint
      lastRewardBlock
      accNvlsPerShare
      balance
      userCount
      owner {
        id
        nvlsPerBlock
        totalAllocPoint
      }
    }
  }
`

export const enceladusPairAddressesQuery = gql`
  query enceladusPairAddresses(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc" # $where: Pool_filter! = { allocPoint_gt: 0, accNvlsPerShare_gt: 0 }
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, where: $where) {
      id
      allocPoint
      accNvlsPerShare
      pair {
        id
      }
    }
  }
`

export const enceladusTotalAllocPointQuery = gql`
  query enceladusTotalAllocPoint($id: String! = "0xc04b9253e1fD6446a20a3a89F2A8257F998eb69D") {
    enceladus(id: $id) {
      id
      totalAllocPoint
    }
  }
`

export const enceladusNvlsPerBlockQuery = gql`
  query enceladusNvlsPerBlock($id: String! = "0xc04b9253e1fD6446a20a3a89F2A8257F998eb69D") {
    enceladus(id: $id) {
      id
      nvlsPerBlock
    }
  }
`

export const enceladusPoolsQuery = gql`
  query enceladusPools(
    $first: Int! = 1000
    $skip: Int! = 0
    $where: Pool_filter!
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
  ) {
    pools(first: $first, skip: $skip, where: $where, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      allocPoint
      accNvlsPerShare
      pair
      balance
      userCount
      owner {
        id
        nvlsPerBlock
        totalAllocPoint
      }
      users(first: 1000, orderBy: "amount", orderDirection: "desc") {
        id
        address
        amount
        block
        rewardDebt
        nvlsHarvested
      }
    }
  }
`

export const enceladusPoolHistoriesQuery = gql`
  query enceladusPoolHistories(
    $first: Int! = 1000
    $skip: Int! = 0
    $where: PoolHistory_filter!
    $orderBy: String! = "timestamp"
    $orderDirection: String! = "desc"
  ) {
    poolHistories(first: $first, skip: $skip, where: $where, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      nvlpBalance
      userCount
      timestamp
      pool {
        id
        allocPoint
        accNvlsPerShare
        pair
        balance
        userCount
        owner {
          id
          nvlsPerBlock
          totalAllocPoint
        }
      }
    }
  }
`
